export default __webpack_public_path__ + "static/media/icon2.d21f79e4.svg";